import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { ITimer } from "@interfaces/timer";
import { AuthService } from "@core/auth.service";
import { TimerService } from "src/app/services/timer.service";
import { Data } from "@angular/router";

@Injectable()
export class VoucherTimerService {
  public $timer: ITimer[] = [];
  public timerInterval: ReturnType<typeof setInterval> | undefined;
  public voucherStartTime = 95000;
  private sub: Subscription;

  constructor(
    private timerService: TimerService,
    private authService: AuthService
  ) {}

  getRemainingExpiryTime(): void {
    this.voucherStartTime = 0;
  }

  sortVouchers(voucherList: Data[]): Data[] {
    let expiryVoucherList = [];
    let validVoucherList = [];

    if (!voucherList) {
      return [];
    }

    voucherList.forEach((element) => {
      if (element?.validTime == 0) expiryVoucherList.push(element);
      else validVoucherList.push(element);
    });

    if (expiryVoucherList.length > 0) {
      expiryVoucherList.sort((x, y) => x?.expiry_date - y?.expiry_date);
    }

    if (validVoucherList.length > 0) {
      validVoucherList.sort((x, y) => x?.validTime - y?.validTime);
    }

    return expiryVoucherList.concat(validVoucherList);
  }

  /**
   * Updates timer fields on a snapshot of the voucher list without re-subscribing to Firestore.
   * Caller should emit the returned array into the matching BehaviorSubject.
   */
  getRemainingTimeSnapshot(current: Data[], event: number, voucher: Data, val: number): Data[] {
    if (!current?.length) {
      return current;
    }
    const res = [...current];
    let sortVoucher = false;

    res.forEach((element) => {
      if (element?.id == voucher?.id) {
        if (val === 1) {
          if (event > 120000) {
            element.validTime = event;
          } else {
            element.validTime = 0;
            sortVoucher = true;
          }
        }
        if (val === 0) {
          if (event > 120000) {
            element.remainingTime = event;
          } else {
            element.remainingTime = 0;
            sortVoucher = true;
          }
        }
      }
    });

    return sortVoucher ? this.sortVouchers(res) : res;
  }

  getCountDown(voucherDetails: Data): void {
    if (this.$timer && this.$timer.length > 0) {
      this.$timer = [];
      clearInterval(this.timerInterval);
    }

    if (voucherDetails) {
      this.timerInterval = setInterval(() => {
        try {
          this.timerService
            ?.multipleTimers(voucherDetails)
            ?.subscribe(
              (iTimer: ITimer[]) => {
                this.$timer = iTimer;
              },
              (err) => {
                this.authService.errorHandlerLogs("[VoucherTimerService.getCountDown]", err);
              }
            );
        } catch (e) {
          this.authService.errorHandlerLogs("[VoucherTimerService.getCountDown]", e);
        }
      }, 1000);
    }
  }

  public buildAwardedVouchers(vList: Data[]): Data[] {
    if (!window.navigator.onLine) {
      return [];
    }

    const list = vList.filter(
      (v: Data) =>
        !v.isRedeemed &&
        !v.hide &&
        v.status &&
        v.start_date.toDate() <= new Date() &&
        v.expiry_date?.toDate() >= new Date(),
    );

    return this.prepareVoucherRows(list);
  }

  public buildUpcomingVouchers(vList: Data[]): Data[] {
    const list = vList.filter((v: Data) => !v.isRedeemed && !v.hide && v.start_date?.toDate() > new Date());
    return this.prepareVoucherRows(list);
  }

  private prepareVoucherRows(list: Data[]): Data[] {
    const finalVoucher: Data[] = [];
    const validVouchers: Data[] = [];
    const now = new Date().getTime();

    list.forEach((voucherList: Data) => {
      const elementDate = voucherList?.start_date?.toDate();
      const expiryDate = voucherList?.expiry_date?.toDate();
      const diff = elementDate ? elementDate.getTime() - now : 0;
      const diff1 = expiryDate ? expiryDate.getTime() - now : 0;

      voucherList.validTime = diff >= 0 ? diff : 0;

      if (diff1 > 60000 && diff < 0) {
        finalVoucher.push(voucherList);
      } else {
        validVouchers.push(voucherList);
      }
    });

    if (validVouchers.length) {
      validVouchers.sort((x, y) => x.validTime - y.validTime);
      finalVoucher.push(...validVouchers);
    }

    return finalVoucher;
  }


  destroy(): void {
    if (this.timerInterval !== undefined) {
      clearInterval(this.timerInterval);
      this.timerInterval = undefined;
    }
    this.sub?.unsubscribe();
  }
}
